/** Locale-aware formatting for inventory. Locale follows the active i18next language. */

import { getIntlLocale } from '@/shared/i18n';

/**
 * Format a stock quantity (thousands separated, following the active locale).
 * Quantities are NOT currency — no ₽/currency symbol is ever attached here.
 */
export function formatQuantity(value?: number | null): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return new Intl.NumberFormat(getIntlLocale(), { maximumFractionDigits: 3 }).format(value);
}

/** Format an ISO timestamp, or an em dash when absent/invalid. */
export function formatDateTime(iso?: string | null): string {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat(getIntlLocale(), {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(date);
}

/** Signed quantity delta with an explicit `+`/`−` sign, for the movement ledger. */
export function formatSignedQuantity(value?: number | null): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  const formatted = new Intl.NumberFormat(getIntlLocale(), { maximumFractionDigits: 3 }).format(
    Math.abs(value),
  );
  if (value > 0) return `+${formatted}`;
  if (value < 0) return `−${formatted}`;
  return formatted;
}
